import React from "react";
import { useState } from 'react';
import { useEffect } from 'react';
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export const LtExportView = (props) => {
  const sectionItem = props.sectionData;
 // console.log(sectionItem);
  /*{sectionItem.exporturl}*/
  return (
    <>
      <div className="lt-export-wrap">
        <div className="downtime-left bcr-export">
          <div className="button-group">
            <a className="download-btn" href={sectionItem.exporturl}>
              Download
            </a>
          </div>
         
        </div>
        
        <div className="button-group bt-grp-nl">
          <a className="download-btn" href={sectionItem.exportlossurl}>
            Export Loss Calculation
          </a>
        </div>
		<div className="button-group bt-grp-nl">
          <a className="download-btn" href={sectionItem.recoverable}>
            Export Recoverable
          </a>
        </div>
      </div>

      <Helmet>
        <link href={require("./lt-export.scss").default} />
      </Helmet>
    </>
  );
};
